import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { Cart, NavCart } from './models';

@Injectable()
export class CartApi {
    public static get(_xmStore: XmStore, http: HttpClient): Observable<Cart> {
        return http.get('/cart', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(map((response: Cart) => Cart.create<Cart>(response)));
    }

    public static getCartCount(_xmStore: XmStore, http: HttpClient): Observable<NavCart> {
        return http.get('/cart', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: Cart) => {
                const cart: Cart = Cart.create<Cart>(response);

                return NavCart.create<NavCart>({ itemCount: cart.items.length });
            }));
    }

}

ModelBase.fetchMapping[StoreAction.GET_CART] = CartApi.get;
ModelBase.fetchMapping[StoreAction.GET_CART_COUNT] = CartApi.getCartCount;
